import { Select as SelectA, type SelectProps } from 'antd';
import type { BaseOptionType, DefaultOptionType } from 'antd/lib/select';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Empty } from '../empty';
import { Icon } from '../icon';

export type SelectProperties<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  ValueType = any,
  OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType,
> = {
  emptyProps?: ComponentProps<typeof Empty>;
} & SelectProps<ValueType, OptionType>;

const Select = <ValueType, OptionType extends BaseOptionType | DefaultOptionType = DefaultOptionType>({
  emptyProps,
  ...props
}: SelectProperties<ValueType, OptionType>) => {
  const { t } = useTranslation();

  return (
    <SelectA<ValueType, OptionType>
      notFoundContent={
        <Empty description={t('No data')} image={<Icon icon="inbox-line" />} size="small" {...emptyProps} />
      }
      size="large"
      {...props}
    />
  );
};

Select.Option = SelectA.Option;

export default Select;
